<div
  [ngClass]="[class]"
  [innerHTML]="labelFullName | paramsTranslate : paramsTranslate ?? [] | popupIndicator | metaUrl | linkStyle"
></div>